import { render, staticRenderFns } from "./RedirectionModal.vue?vue&type=template&id=59987ca1&scoped=true"
import script from "./RedirectionModal.vue?vue&type=script&lang=js"
export * from "./RedirectionModal.vue?vue&type=script&lang=js"
import style0 from "./RedirectionModal.vue?vue&type=style&index=0&id=59987ca1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59987ca1",
  null
  
)

export default component.exports